import { styled } from 'mz-ui-kit'
import { getScreenStyles } from 'mz-ui-kit/utils'


export const Container = styled('div', {
  userSelect: 'none'
})

export const SwapLocations = styled('div', ({ $palette, $disabled }) => ({
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '14px',
  background: 'white',
  color: `${$palette('PRIMARY')}`,
  cursor: 'pointer',
  position: 'absolute',
  top: '25px',
  right: '-11px',
  zIndex: '100',
  width: '20px',
  height: '20px',
  border: `1px solid ${$palette('PRIMARY')}`,
  borderRadius: '50%',
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  pointerEvents: $disabled ? 'none' : 'inherit',
  opacity: $disabled ? 0.5 : 1,
  ...getScreenStyles('xs', {
    marginTop: '-10px',
    top: 'auto',
    bottom: '6px',
    right: '15px',
    marginBottom: '-20px',
    alignSelf: 'flex-end',
    marginRight: '10px',
    width: '28px',
    height: '28px',
    fontSize: '18px',
    transform: 'rotate(90deg)',
  }),
}))
